/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import RenderTextField from '../../../../../utils/renderFields/RenderTextField';
import RenderSelectFieldUpdateCommand from '../../../../../utils/renderFields/RenderSelectFieldUpdateCommand';
import validate from '../validate';
import { updateCommand, updateCommandAddress } from '../../../commandsActions';
import countryCodeBinding from '../../../../../utils/bindings/countryCode';
import GenerateReturnLabel from './GenerateReturnLabelButton';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 50px 0px;
`;

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  }
}));

/* eslint-disable import/no-mutable-exports */
let RecipientTab = ({
  handleSubmit,
  canAddressBeChanged,
  canGenerateReturnLabel,
  commandId
}) => {
  const classes = useStyles();
  return (
    <form className={classes.form} onSubmit={handleSubmit} noValidate>
      <Grid container justify="center" spacing={7}>
        <Grid item md={6}>
          <Field
            name="recipient.lastname"
            id="lastname"
            label="Nom"
            fullWidth
            disabled={!canAddressBeChanged}
            displayErrorBeforeSubmit
            component={RenderTextField}
          />
        </Grid>
        <Grid item md={6}>
          <Field
            name="recipient.firstname"
            id="firstname"
            label="Prénom"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
      </Grid>
      <Grid container justify="center" spacing={7}>
        <Grid item md={6}>
          <Field
            name="recipient.phoneNumber"
            id="phoneNumber"
            label="Numéro de téléphone"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
        <Grid item md={6}>
          <Field
            name="recipient.email"
            id="email"
            label="Adresse email"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
      </Grid>
      <Grid container justify="center" spacing={7}>
        <Grid item md={6}>
          <Field
            name="recipient.companyName"
            id="companyName"
            label="Entreprise"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
        <Grid item md={6}>
          <Field
            name="recipientAddress.street"
            id="street"
            label="Rue 1"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
      </Grid>
      <Grid container justify="center" spacing={7}>
        <Grid item md={6}>
          <Field
            name="recipientAddress.street2"
            id="street2"
            label="Rue 2"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
        <Grid item md={6}>
          <Field
            name="recipientAddress.city"
            id="city"
            label="Ville"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
      </Grid>

      <Grid container spacing={7}>
        <Grid item md={12}>
          <Field
            name="recipientAddress.complement"
            id="complement"
            label="Complément"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
      </Grid>

      <Grid container justify="center" spacing={7}>
        <Grid item md={6}>
          <Field
            name="recipientAddress.postalCode"
            id="postalCode"
            label="Code postal"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            component={RenderTextField}
          />
        </Grid>
        <Grid item md={6}>
          <Field
            name="recipientAddress.countryCode"
            id="countryCode"
            label="Pays"
            fullWidth
            displayErrorBeforeSubmit
            disabled={!canAddressBeChanged}
            style={{ width: '100%' }}
            component={RenderSelectFieldUpdateCommand}
            datas={countryCodeBinding}
          />
        </Grid>
      </Grid>
      <ButtonContainer>
        {canAddressBeChanged && (
          <Button variant="contained" color="primary" type="submit">
            Mettre à jour
          </Button>
        )}
        {canGenerateReturnLabel && (
          <GenerateReturnLabel commandId={commandId} />
        )}
      </ButtonContainer>
    </form>
  );
};

const mapStateToProps = state => {
  const {
    recipientFirstname,
    recipientLastname,
    recipientCompanyName,
    recipientPhoneNumber,
    recipientEmail,
    canAddressBeChanged,
    id,
    canBeCancelled,
    recipientAddress: {
      city,
      complement,
      countryCode,
      postalCode,
      street,
      street2
    }
  } = state.commands.currentCommand;
  return {
    canAddressBeChanged,
    commandId: id,
    canBeCancelled,
    currentCommand: state.commands.currentCommand,
    initialValues: {
      recipient: {
        lastname: recipientLastname,
        firstname: recipientFirstname,
        phoneNumber: recipientPhoneNumber,
        email: recipientEmail,
        companyName: recipientCompanyName
      },
      recipientAddress: {
        city,
        countryCode,
        complement,
        postalCode,
        street,
        street2
      }
    }
  };
};

RecipientTab = reduxForm({
  form: 'updateRecipientInformationsForm',
  validate,
  onSubmit: (values, dispatch, props) => {
    const command = {
      ...props.currentCommand,
      ...values,
      offerCode: props.currentCommand.offer.code,
      recipientCompanyName: values.companyName,
      recipientFirstname: values.firstname,
      recipientLastname: values.lastname,
      recipientEmail: values.email,
      recipientPhoneNumber: values.phoneNumber
    };
    if (props.updateOnlyCommandAddress === true) {
      const address = {
        id: command.id,
        address: { ...command.recipientAddress },
        firstname: command.recipient.firstname,
        lastname: command.recipient.lastname,
        companyName: command.recipient.companyName,
        phoneNumber: command.recipient.phoneNumber,
        email: command.recipient.email
      };
      dispatch(updateCommandAddress(address));
    } else {
      dispatch(updateCommand(command));
    }
  }
})(RecipientTab);

RecipientTab.propTypes = {
  handleSubmit: PropTypes.func,
  canAddressBeChanged: PropTypes.bool.isRequired,
  commandId: PropTypes.number.isRequired,
  canGenerateReturnLabel: PropTypes.bool
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(RecipientTab)
);
